"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
var _LineChart = require("@mui/x-charts/LineChart");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : GraphHumidity.js
* Description : Ce fichier contient la définition du composant GraphHumidity 
*               Ce composant affiche un graphique avec des courbes sur les données d'humidité
* Date de création : 22 juillet 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* GraphHumidity : ce composant affiche un graphique avec des courbes sur les données d'humidité
*
* Type : composant 
*
* Parametres : 
*  - data -- données d'humidité
*  - limit_value -- valeur de la limite pour déterminer un taux d'humidité excessive
*/function GraphHumidity(_ref) {
  var data = _ref.data,
    limit_value = _ref.limit_value;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  if (limit_value == null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LineChart.LineChart, {
        height: 300,
        series: [{
          data: data.map(function (item) {
            return item.humidity;
          }),
          label: 'Humidité (%)',
          showMark: true,
          // obligatoire pour rendre les points 
          shape: 'circle',
          color: 'purple'
        }],
        xAxis: [{
          scaleType: 'point',
          data: data.map(function (item) {
            return item.datetime;
          })
        }],
        yAxis: [{
          min: 0,
          max: 100
        }],
        margin: {
          right: 24
        }
      })
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LineChart.LineChart, {
        height: 300,
        series: [{
          data: data.map(function (item) {
            return item.ambient_humidity;
          }),
          label: 'Humidité ambiente (%)',
          showMark: true,
          // obligatoire pour rendre les points
          shape: 'diamond',
          color: 'cyan'
        }, {
          data: data.map(function (item) {
            return item.humidity;
          }),
          label: 'Humidité (%)',
          showMark: true,
          // obligatoire pour rendre les points 
          shape: 'circle',
          color: 'purple'
        }, {
          data: Array(data.length).fill(limit_value),
          label: 'Limite d\'humidité excessive(%)',
          showMark: false,
          color: 'red'
        }, {
          data: data.map(function (item) {
            return item.failure === 1 ? item.humidity : null;
          }),
          label: 'Panne',
          showMark: true,
          shape: 'cross',
          color: 'orange'
        }],
        xAxis: [{
          scaleType: 'point',
          data: data.map(function (item) {
            return item.datetime;
          })
        }],
        yAxis: [{
          min: 0,
          max: 100
        }],
        margin: {
          right: 24
        }
      })
    });
  }
}
var _default = exports["default"] = GraphHumidity;